module.exports = __webpack_public_path__ + "img/sign-default.19a49355.png";